// OneDrive:IgnoreCodeCoverage
import { ControlPerformanceData } from "./RUMOneLogger";

export default ControlPerformanceData;